export const API_BASE_URL = "https://userapi.hly520.cn";

export const AGREEMENT_TYPES = {
  userAgreement: "userinfo",
  privacyPolicy: "userprivacyinfo",
};
